export default "__VITE_ASSET__CsP4ZJvZ__"